import { render, staticRenderFns } from "./AppHooperImageSlider.vue?vue&type=template&id=6ed8cbfa&scoped=true"
import script from "./AppHooperImageSlider.vue?vue&type=script&lang=js"
export * from "./AppHooperImageSlider.vue?vue&type=script&lang=js"
import style0 from "./AppHooperImageSlider.vue?vue&type=style&index=0&id=6ed8cbfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed8cbfa",
  null
  
)

export default component.exports